import { action }         from 'mobx';
import { makeObservable } from 'mobx';
import { observable }     from 'mobx';
import type { Section }   from '@/TokamapEditor/ux/AreaSidebar/AreaSidebar';

export type PlacePanelLevel = Section;

export class PlacePanelStore {
	@observable level: PlacePanelLevel = 'place';

	constructor() {
		makeObservable(this);
	}

	@action setLevel(level: PlacePanelLevel) {
		this.level = level;
	}
}

export default new PlacePanelStore();
